import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Session, User } from '@supabase/supabase-js'

interface AuthState {
  session: Session | null
  user: User | null
  isPlatformAdmin: boolean
  initialized: boolean
  adminCheckPending: boolean
  setSession: (session: Session | null) => void
  setIsPlatformAdmin: (value: boolean) => void
  setInitialized: (initialized: boolean) => void
  setAdminCheckPending: (v: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      user: null,
      isPlatformAdmin: false,
      initialized: false,
      adminCheckPending: true,
      setSession: (session) =>
        set({ session, user: session?.user ?? null }),
      setIsPlatformAdmin: (isPlatformAdmin) => set({ isPlatformAdmin }),
      setInitialized: (initialized) => set({ initialized }),
      setAdminCheckPending: (adminCheckPending) => set({ adminCheckPending }),
      clear: () =>
        set({ session: null, user: null, isPlatformAdmin: false }),
    }),
    {
      name: 'oneidol-admin-auth',
      // Don't persist session — let Supabase SDK manage it
      partialize: () => ({}),
    }
  )
)
